import { TREATMENTS } from './toggles-definition';
import { SplitFeatureToggles } from './sdk';
import { getEnvironment } from '../environment/getEnvironment';

const { getToggle, initialize, setClientId: setClient } = SplitFeatureToggles;

export const setClientId = setClient;

export const InitializeSplit = async (country: string) => {
  const {
    featureFlagging: { apiKeyBR, apiKeyCO },
  } = await getEnvironment();
  const key = country.toLocaleLowerCase() === 'co' ? apiKeyCO : apiKeyBR;
  if (!key) {
    throw 'SPLIT_KEY is not set, please check your env';
  }
  await initialize(key);
};

export const getSplitToggle = async (country: string) => {
  await InitializeSplit(country);
  return {
    preApprovalVersion: (
      ctx?: Record<string, string | number | boolean | Array<string | number>>
    ) => {
      return getToggle(TREATMENTS.preApprovalVersion, ctx).getValue();
    },
    healthcheckEnable: (
      ctx?: Record<string, string | number | boolean | Array<string | number>>
    ) => {
      return getToggle(TREATMENTS.ecommerceMonitoring, ctx).isEnabled();
    },
  };
};
